import { MessagingExecutionType } from './messagingExecutionType';
import { TriggerKey } from '../userCommunicationAgent';

// Google Chat trigger configs

export interface GoogleChatNewMessageTriggerConfig {
  executionType: MessagingExecutionType;
}

export interface GoogleChatSpaceMatchTriggerConfig {
  /** Google Chat space resource names, e.g. `spaces/AAAA…` */
  spaces: string[];
  emailAddress: string;
  executionType?: MessagingExecutionType;
}

export interface GoogleChatAuthorMatchTriggerConfig {
  /** Google Chat member IDs, e.g. `users/123…` */
  authorIds: string[];
  emailAddress: string;
  executionType?: MessagingExecutionType;
}

// Google Chat step configs

export interface SendGoogleChatMessageStepConfig {
  emailAddress: string;
  spaceName: string;
  message: string;
  threadName?: string;
}

export const GOOGLE_CHAT_TRIGGER_KEYS = [
  TriggerKey.GOOGLE_CHAT_NEW_MESSAGE,
  TriggerKey.GOOGLE_CHAT_SPACE_MATCH,
  TriggerKey.GOOGLE_CHAT_AUTHOR_MATCH,
];
